function BarIndicator({ value, max = 100, color = '#3B82F6' }) {
  const pct = Math.min((value / max) * 100, 100)
  return (
    <div className="w-full h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden mt-1">
      <div
        className="h-full rounded-full"
        style={{ width: `${pct}%`, backgroundColor: color }}
      />
    </div>
  )
}

function ThreatProfileSummary({ topActors, topVectors, topAssets, profileName }) {
  return (
    <div>
      {profileName && (
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">
          Profile: <span className="font-medium text-gray-700 dark:text-gray-300">{profileName}</span>
        </p>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
            Top Threat Actors
          </p>
          <p className="text-[10px] text-gray-400 dark:text-gray-500 mb-2">Likelihood of targeting your organization</p>
          <div className="space-y-2.5">
            {(topActors || []).slice(0, 4).map((actor) => (
              <div key={actor.name} className="group">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-900 dark:text-white">{actor.name}</span>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {Math.round((actor.adjustedLikelihood || actor.likelihood || 0) * 100)}%
                  </span>
                </div>
                <BarIndicator value={(actor.adjustedLikelihood || actor.likelihood || 0) * 100} color="#EF4444" />
                {actor.description && (
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 hidden group-hover:block">{actor.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        <div>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
            Top Attack Vectors
          </p>
          <p className="text-[10px] text-gray-400 dark:text-gray-500 mb-2">Prevalence of attack methods in your industry</p>
          <div className="space-y-2.5">
            {(topVectors || []).slice(0, 4).map((vector) => (
              <div key={vector.name} className="group">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-900 dark:text-white">{vector.name}</span>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {Math.round((vector.adjustedPrevalence || vector.prevalence || 0) * 100)}%
                  </span>
                </div>
                <BarIndicator value={(vector.adjustedPrevalence || vector.prevalence || 0) * 100} color="#F59E0B" />
                {vector.description && (
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 hidden group-hover:block">{vector.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        <div>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
            Target Assets
          </p>
          <p className="text-[10px] text-gray-400 dark:text-gray-500 mb-2">Criticality of assets attackers prioritize</p>
          <div className="space-y-2.5">
            {(topAssets || []).slice(0, 4).map((asset) => (
              <div key={asset.name} className="group">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-900 dark:text-white">{asset.name}</span>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {Math.round((asset.adjustedCriticality || asset.criticality || 0) * 100)}%
                  </span>
                </div>
                <BarIndicator value={(asset.adjustedCriticality || asset.criticality || 0) * 100} color="#8B5CF6" />
                {asset.description && (
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 hidden group-hover:block">{asset.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <p className="text-[10px] text-gray-400 dark:text-gray-500 mt-4 pt-3 border-t border-gray-100 dark:border-gray-700/30">
        Sources: Verizon DBIR 2024, CrowdStrike Global Threat Report 2024, IBM X-Force Threat Intelligence Index 2024, FS-ISAC Annual Threat Report. Adjusted for organizational profile.
      </p>
    </div>
  )
}

export default ThreatProfileSummary
